import { Component, Input, OnInit } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { PatientAttachmentsService } from '../../../core/services/patient-attachments.service';

@Component({
  selector: 'app-patient-document-form',
  templateUrl: './patient-document-form.component.html',
  standalone: false
})
export class PatientDocumentFormComponent implements OnInit {
  @Input() capture: Capture;
  @Input() selectedAttachment: PatientAttachment;

  constructor(
    private patientAttachmentsService: PatientAttachmentsService,
  ) { }

  ngOnInit() {
    this.patientAttachmentsService.patientAttachmentChanged.subscribe(({ patientAttachment }) => {
      if (patientAttachment.id === this.selectedAttachment.id) {
        this.handlePatientAttachmentChange(patientAttachment);
      }
    });
  }

  private handlePatientAttachmentChange(patientAttachment: PatientAttachment) {
    this.patientAttachmentsService
      .getStatus(patientAttachment.id)
      .subscribe((result) => {
        patientAttachment.hasMatchingSpecialtyPmvs = result.hasMatchingSpecialtyPmvs;
        this.selectedAttachment = patientAttachment;
      });
  }
}
